import React from "react";

export default function AboutPage() {
  return (
    <div style={{ maxWidth: 900, margin: "0 auto", padding: "40px 20px", textAlign: "left" }}>
      <h2 style={{ textAlign: "center", marginBottom: 24 }}>About Articulate Intelligence</h2>

      <p style={{ lineHeight: 1.7, color: "#374151" }}>
        Articulate Intelligence is an education technology platform developed by MapleTech Pte Ltd.
        The platform focuses on supporting teachers and students through AI-assisted tools for
        learning and assessment.
      </p>

      <p style={{ lineHeight: 1.7, color: "#374151" }}>
        The Composition AI Grader is designed to help teachers assess English writing, including
        Continuous Writing and Situational Writing, based on curriculum-aligned marking rubrics
        used in Singapore schools. It provides structured feedback to support student improvement
        while reducing teacher marking workload.
      </p>

      <p style={{ lineHeight: 1.7, color: "#374151" }}>
        The platform is built to be simple and accessible, allowing teachers to upload student
        scripts and receive feedback efficiently. It is intended for educational use in schools
        and supports classroom learning and assessment.
      </p>
    </div>
  );
}
